<template>
  <div id="chart-table-box">
    <chart-title leftTitle="MES订单预警系统 right_10"></chart-title>
    <div id="chart-table">
      <!-- <div class="table-title-item">
        <dv-decoration-7 class="table-title table-title-first"
          ><span class="table-title-text">生产延期统计</span></dv-decoration-7
        >
        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="{ ...config, data: configData1 }"
        style="width: 100%; height: 16%; margin-top: 10px"
      /> -->
      <div class="table-title-item">
        <subtitle-1
          :iconLeft="'biaotijiantou'"
          :iconRight="'biaotijiantou-right'"
          :title="'下生产预警'"
          :width="'20px'"
          :height="'20px'"
          class="table-title"
        ></subtitle-1>
        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="{ ...config, data: configData2 }"
        style="width: 100%; height: 16%; margin-top: 10px"
      />
      <div class="table-title-item">
        <subtitle-1
          :iconLeft="'biaotijiantou'"
          :iconRight="'biaotijiantou-right'"
          :width="'20px'"
          :height="'20px'"
          :title="'交货周期预警'"
          class="table-title"
        ></subtitle-1>

        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="{ ...config, data: configData3 }"
        style="width: 100%; height: 16%; margin-top: 10px"
      />
      <div class="table-title-item">
        <subtitle-1
          :iconLeft="'biaotijiantou'"
          :iconRight="'biaotijiantou-right'"
          :width="'20px'"
          :height="'20px'"
          :title="'售后超时预警'"
          class="table-title"
        ></subtitle-1>

        <el-button
          type="primary"
          slot="detail"
          size="mini"
          style="margin-right: 20px"
          >详 情</el-button
        >
      </div>
      <dv-scroll-board
        :config="{ ...config, data: configData3 }"
        style="width: 100%; height: 16%; margin-top: 10px"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import Subtitle1 from "../../../components/subtitle-1";
export default {
  mixins: [resize],
  name: "right_10",
  components: { ChartTitle, Subtitle1 },
  data() {
    return {
      config: {
        rowNum: 3,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        // align: [
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        //   "center",
        // ],
        // columnWidth: ["", "", "", "", "", "", ""],
      },
      configData1: [
        [
          `<span style="color:#409EFF">订单号</span>`,
          `<span style="color:#409EFF">商家</span>`,
          `<span style="color:#409EFF">客户信息</span>`,
          `<span style="color:#409EFF">转单天数</span>`,
        ],
        [
          `<span style="color:#409EFF">订单号</span>`,
          `<span style="color:#409EFF">商家</span>`,
          `<span style="color:#409EFF">客户信息</span>`,
          `<span style="color:#409EFF">转单天数</span>`,
        ],
        [
          `<span style="color:#409EFF">订单号</span>`,
          `<span style="color:#409EFF">商家</span>`,
          `<span style="color:#409EFF">客户信息</span>`,
          `<span style="color:#409EFF">转单天数</span>`,
        ],
        [
          `<span style="color:#409EFF">订单号</span>`,
          `<span style="color:#409EFF">商家</span>`,
          `<span style="color:#409EFF">客户信息</span>`,
          `<span style="color:#409EFF">转单天数</span>`,
        ],
      ],
      configData2: [
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
      ],
      configData3: [
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
        [
          `<span style="color:#409EFF">当前状态</span>`,
          `<span style="color:#409EFF">20221216000</span>`,
          `<span style="color:#409EFF">商家名</span>`,
          `<span style="color:#409EFF">客户名</span>`,
          `<span style="color:#409EFF">2022-12-14</span>`,
          `<span style="color:${this.getColor(-2)}">-2天</span>`,
        ],
      ],
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {
    getColor(val) {
      if (val == 0) {
        return "#fee588";
      } else if (val < 0) {
        return "#F56C6C";
      } else {
        return "#409EFF";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 45vh;

  #chart-table {
    padding: 0 10px;
    background: transparent;
    height: calc(100% - 30px);

    .table-title {
      margin: 20px 0px 0px 5px;
    }
  }
  .table-title-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
}
</style>

